<template lang="pug">
  div.tech-list
    figure.tech-list__name(v-for="tech in techs" v-in-viewport.once="true")
      img(:src="tech.src" :alt="tech.name")
      figcaption {{ tech.name }}
</template>


<script>
  export default {
    name: 'Techs',

    data: () => ({
      techs: [
        { name: 'HTML5', src: require('../assets/images/logos/html5.svg') },
        { name: 'CSS3', src: require('../assets/images/logos/css3.svg') },
        { name: 'JavaScript', src: require('../assets/images/logos/javascript.svg') },
        { name: 'Vue', src: require('../assets/images/logos/vuejs.svg') },
        { name: 'Webpack', src: require('../assets/images/logos/webpack.svg') },
        { name: 'Bootstrap', src: require('../assets/images/logos/bootstrap.svg') },
        { name: 'Sass', src: require('../assets/images/logos/sass.svg') },
        // { name: 'Node.js', src: require('../assets/images/logos/nodejs.svg') },
        { name: 'jQuery', src: require('../assets/images/logos/jquery.svg') },
        { name: 'Angular2+', src: require('../assets/images/logos/angular2.svg') },
        { name: 'WordPress', src: require('../assets/images/logos/wordpress.svg') }
      ]
    })
  }
</script>


<style lang="sass">
  .tech-list
    display: flex
    flex-wrap: wrap
    justify-content: space-between
    margin: 4em 0
    margin-left: -5vw // wtf?
    +unselectable
    &__name
      width: 45%
      margin: 0
      padding-bottom: 40px
      text-align: center
      opacity: 0
      +breakpoint(sm)
        padding-bottom: 60px
        width: 19.5%
      // Animation
      @for $i from 1 through 12
        &:nth-of-type(#{$i})
          &.in-viewport
            animation: (0.5s + ($i - 1) * 0.1s) fadeInUp2 (600ms + ($i - 1) * 0.1s) both

      > img
        display: inline-block
        width: 50%

      > figcaption
        font-weight: 200
        font-size: .850rem
        margin: 0 auto
        max-width: 170px
        +breakpoint(md)
          font-size: 1rem
        +breakpoint(lg)
          font-size: 1.250rem
</style>



// WEBPACK FOOTER //
// src/components/Techs.vue